// eslint-disable-next-line import/no-unresolved
import Middleware from './middleware';

const signupUrls = '/sell/,/sumoday,/sumoday/';
const sellPage = 'https://sell.appsumo.com/';
const signupRoute = '/accounts/signup/';
const loginRoute = '/accounts/login/';

Middleware.authenticate = function authenticateMiddleware({
  store, redirect, route, req,
}) {
  const session = store.state?.session;

  if (!session) {
    // eslint-disable-next-line no-console
    console.error('[Authenticate] session state is not defined');
  }

  if (!session?.user) {
    let referrer = null;

    if (process.server) {
      referrer = req.headers.referer;
    } else {
      referrer = document.referrer;
    }

    // If they landed to the portal via a direct link like /partners/products/
    // then the referrer is undefined in the nuxt request.
    referrer = referrer || '';

    const referrerChunks = referrer.split('appsumo.com');
    const referrerUrl = referrerChunks[1];

    if (referrer === sellPage || signupUrls.includes(referrerUrl)) {
      return redirect(`${signupRoute}?next=${route.fullPath}`);
    }

    return redirect(`${loginRoute}?next=${route.fullPath}`);
  }

  return null;
};
